import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { types as actions, downloadedTagListAction } from '../../reducers/actions';
import { TagService, FileService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EXPORT_TAG_LIST),
    switchMap(action =>
      TagService.exportTagList(action.siteId, action.queryParams).pipe(
        map(data => {
          FileService.downloadInBrowser(data, 'tag-list.csv');
          return downloadedTagListAction();
        })
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/tags/downloadTagList.js